import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type { Distributors, UseGetDistributorsQueryKey } from './types';
import { getUseGetDistributorsQueryKey } from './utils';

export const useGetDistributors: QueryFunction<
  Distributors,
  [],
  UseGetDistributorsQueryKey
> = (params = {}) => {
  const { requestOptions } = params;
  const request = useRequest(requestOptions);
  const queryKey = getUseGetDistributorsQueryKey();

  return useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      return request('/products/distributors', {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
  });
};
